import { render } from "./SessionResultsModal.vue?vue&type=template&id=a296989e"
import script from "./SessionResultsModal.vue?vue&type=script&lang=js"
export * from "./SessionResultsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__